import { createContext } from 'react';

import { AuthContextInterface, defaultInterface } from '../../models/auth-context-interface';

const AuthContext = createContext<AuthContextInterface>(defaultInterface);

export { AuthContext };
